export default __webpack_public_path__ + "static/media/enviroai_new.dff8e4e4.svg";